import { useAuth } from "react-oidc-context";
import { NavLink } from "react-router-dom";

import { buildLogoutUrl, isAdmin } from "../auth";
import { cn } from "../lib/cn";

const links = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/inbox", label: "Inbox" },
  { to: "/profile", label: "Profile" },
  { to: "/runs", label: "Runs" },
  { to: "/settings", label: "Settings" },
];

export function Nav() {
  const auth = useAuth();
  const email = auth.user?.profile.email ?? "";
  const admin = isAdmin(auth.user?.profile);
  const navLinks = admin ? [...links, { to: "/admin", label: "Admin" }] : links;

  return (
    <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-3">
        <div className="flex items-center gap-6">
          <span className="font-semibold tracking-tight text-accent">JobHunter</span>
          <nav className="flex items-center gap-1 text-sm">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  cn(
                    "rounded-md px-3 py-1.5 text-slate-300 transition hover:bg-slate-800 hover:text-slate-100",
                    isActive && "bg-slate-800 text-slate-50",
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-400">
          <span>{email}</span>
          <button
            type="button"
            className="rounded-md border border-slate-700 px-2 py-1 text-slate-200 transition hover:border-slate-500 hover:bg-slate-800"
            onClick={() => {
              auth.removeUser();
              window.location.assign(buildLogoutUrl());
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
